<app-route-name-bar [routeName]="'PROFILE.NAME'"></app-route-name-bar>
<div class="profile-container">
  <div class="profile-box w-depth">
    <div class="image-box">
      <div class="image-box-blur" [ngStyle]="{'background': background}"></div>
      <div class="profile-pic-box w-depth" [ngClass]="{'default-background' : !customer?.pictureURL}">
        <div class="profile-pic" *ngIf="customer?.pictureURL"
             [ngStyle]="{'background': 'url('+customer.pictureURL+') center center no-repeat'}"></div>
      </div>
      <button class="w-round-btn upload-btn" *ngIf="showEditFrom" (click)="picturesDialog()">
        <i class="mdi mdi-camera"></i>
      </button>
      <button class="w-round-btn edit-btn" *ngIf="!showEditFrom" (click)="editProfile()">
        <i class="mdi mdi-pencil"></i>
      </button>
    </div>
    <div class="info-box">
      <div class="name" *ngIf="!showEditFrom">{{customer?.displayName}}</div>
      <div class="details-box w-depth">
        <form [formGroup]="editForm">
          <table>
            <tr *ngIf="showEditFrom">
              <td class="icon-cell">
                <div class="icon">
                  <i class="mdi mdi-account"></i>
                </div>
              </td>
              <td class="detail-cell">
                <div class="detail">
                  <input name="displayName" formControlName="displayName" placeholder="John"
                         [title]="'PROFILE.FORMNAME'| translate">
                </div>
                <div class="detail-desc">{{'PROFILE.FORMNAME'| translate}}</div>
              </td>
            </tr>
            <tr>
              <td class="icon-cell">
                <div class="icon">
                  <i class="mdi mdi-cellphone"></i>
                </div>
              </td>
              <td class="detail-cell">
                <div class="detail">
                  <span *ngIf="!showEditFrom">{{customer?.phone | phone}}</span>
                  <span *ngIf="showEditFrom">
                    <input name="phone" formControlName="phone" placeholder="(123) 456-8912"
                           [title]="'PROFILE.FORMPHONE'| translate" [textMask]="{mask: phoneMask}">
                  </span>
                </div>
                <div class="detail-desc">{{'PROFILE.FORMPHONE'| translate}}</div>
              </td>
            </tr>
            <tr>
              <td class="icon-cell">
                <div class="icon">
                  <i class="mdi mdi-email"></i>
                </div>
              </td>
              <td class="detail-cell">
                <div class="detail">
                  <span *ngIf="!showEditFrom">{{customer?.email}}</span>
                  <span *ngIf="showEditFrom">
                    <input name="email" formControlName="email" placeholder="mail@mail.com"
                           [title]="'PROFILE.FORMEMAIL'| translate">
                  </span>
                </div>
                <div class="detail-desc">{{'PROFILE.FORMEMAIL'| translate}}</div>
              </td>
            </tr>
          </table>
        </form>
      </div>
      <div class="form-btns" *ngIf="showEditFrom">
        <button class="w-btn orange-btn btn-wave" (click)="saveUpdates(editForm)">{{'DONE'| translate}}</button>
        <button class="w-btn grey-btn btn-wave" (click)="cancelEdit()">{{'CANCEL'| translate}}</button>
      </div>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
</div>
